import { useMemo } from 'react'
import { type MapContent, type MapPOI } from '../utils'
import PlotOccupantLabel from './PlotOccupantLabel'
import styles from './HousingMap.module.scss'
import PlotImage from './PlotImage'
import type { DisplayOccupant } from './types'

type Props = {
  mapId: number
  neighborhood: MapContent
  occupantsByPlot: Record<string, DisplayOccupant[]>
  shardIndex: number
  hoveringPlot: string | null
  setHoveringPlot: (plot: string | null) => void
  onOpenPlot: (plot: MapPOI) => void
}

const PlotGrid = ({
  mapId,
  neighborhood,
  occupantsByPlot,
  shardIndex,
  hoveringPlot,
  setHoveringPlot,
  onOpenPlot,
}: Props) => {
  const sortedPlots = useMemo(() => {
    return [...neighborhood.POIs]
      .sort((a, b) => parseInt(a.Name) - parseInt(b.Name))
      .filter((poi) => poi.Type === 'Plot')
  }, [neighborhood.POIs])

  return (
    <div className={styles.plotGrid}>
      {sortedPlots.map((plot) => {
        const occupants = (occupantsByPlot[plot.Name] ?? []).filter(
          (occupant) => occupant.shard_index === shardIndex,
        )
        const approved = occupants.find(
          (occupant) => occupant.status === 'approved',
        )

        return (
          <button
            key={plot.Name}
            type='button'
            className={`${styles.plotGridItem} ${
              hoveringPlot === plot.Name ? styles.plotGridItemActive : ''
            }`}
            onMouseEnter={() => setHoveringPlot(plot.Name)}
            onMouseLeave={() => setHoveringPlot(null)}
            onClick={() => onOpenPlot(plot)}
          >
            <div className={styles.plotGridOverlay}>
              <div className={styles.plotGridNumber}>{plot.Name}</div>

              <div className={styles.plotGridOccupant}>
                <PlotOccupantLabel occupants={occupants} />
              </div>
            </div>

            <PlotImage
              className={`h-full w-full object-cover ${
                approved ? 'grayscale' : ''
              }`}
              mapId={mapId}
              plotId={plot.Name}
            />
          </button>
        )
      })}
    </div>
  )
}

export default PlotGrid
